export default __webpack_public_path__ + "/dist/images/buyer-icon.3cdbd4a6fb3dc8bd65424f32b801c0d3.svg";